import Error404 from '@/views/error/Error404.vue'
import Login from '@/views/pages/authentication/Login.vue'
// import Register from '@/views/pages/authentication/Register.vue'
import ForgotPassword from '@/views/pages/authentication/ForgotPassword.vue'
import AccountSetting from '@/views/pages/account-setting/AccountSetting.vue'
import ResetPassword from '@/views/pages/authentication/ResetPassword.vue'
import Subscriptions from '@/views/pages/subscriptions/Subscriptions.vue'

export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: Error404,
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read'
    }
  },
  {
    path: '/login',
    name: 'auth-login',
    component: Login,
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true
    }
  },
  {
    path: '/register',
    name: 'auth-register',
    beforeEnter() {
      window.location.href = 'https://www.hostmatic.io/signup'
    }
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: ForgotPassword,
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true
    }
  },
  {
    path: '/reset-password/:uuid',
    name: 'auth-reset-password',
    component: ResetPassword,
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true
    }
  },
  {
    path: '/pages/account-setting',
    name: 'pages-account-setting',
    component: AccountSetting,
    meta: {
      pageTitle: 'Profile',
      breadcrumb: [
        {
          text: 'Account Settings',
          active: true
        }
      ]
    }
  },
  {
    path: '/pages/subscriptions',
    name: 'pages-subscriptions',
    component: Subscriptions,
    meta: {
      pageTitle: 'Subscriptions'
    }
  }
]
